/**
 * State object
 */ const $ce3de23872348272$export$ca000e230c0caa3e = {
    selectedRate: 0,
    selectedRateButton: null
};
const $ce3de23872348272$export$aad8462122ac592b = ()=>{
    $ce3de23872348272$export$ca000e230c0caa3e.selectedRate = 0;
    $ce3de23872348272$export$ca000e230c0caa3e.selectedRateButton = null;
};
const $ce3de23872348272$export$e0729daa42e99137 = (rate)=>{
    $ce3de23872348272$export$ca000e230c0caa3e.selectedRate = rate;
};
const $ce3de23872348272$export$4f71040b6c38b2f4 = (element)=>{
    $ce3de23872348272$export$ca000e230c0caa3e.selectedRateButton = element;
};


let $f9a85cdfa1754a18$var$elements = {};
const $f9a85cdfa1754a18$export$5ac527444e5e2edd = ()=>{
    $f9a85cdfa1754a18$var$elements = {
        starImages: {
            all: document.querySelectorAll(".star-img"),
            star1: document.getElementById("star-1"),
            star2: document.getElementById("star-2"),
            star3: document.getElementById("star-3"),
            star4: document.getElementById("star-4"),
            star5: document.getElementById("star-5")
        },
        rateNumbersBtns: {
            all: document.querySelectorAll(".rate-number"),
            num1: document.getElementById("number-1"),
            num2: document.getElementById("number-2"),
            num3: document.getElementById("number-3"),
            num4: document.getElementById("number-4"),
            num5: document.getElementById("number-5")
        },
        submitButton: document.getElementById("submit-button"),
        errorMessage: document.getElementById("submit-help"),
        rateAndSubmitSection: document.getElementById("rate-submit-section"),
        thankYouPopup: document.getElementById("thank-you-section"),
        popupSelectedRate: document.getElementById("selected-rate")
    };
};
const $f9a85cdfa1754a18$export$7fa453720b850f25 = ()=>{
    // Check individual elements
    const requiredSingleElements = [
        "submitButton",
        "errorMessage",
        "rateAndSubmitSection",
        "thankYouPopup",
        "popupSelectedRate"
    ];
    requiredSingleElements.forEach((key)=>{
        if (!$f9a85cdfa1754a18$var$elements[key]) throw new Error(`Required DOM element not found: ${key}`);
    });
    // Check star images separately
    if (!$f9a85cdfa1754a18$var$elements.starImages?.all || $f9a85cdfa1754a18$var$elements.starImages.all.length !== 5) throw new Error(`Expected 5 star images, found: ${$f9a85cdfa1754a18$var$elements.starImages?.all?.length ?? 0}`);
    // Check rate number buttons separately
    if (!$f9a85cdfa1754a18$var$elements.rateNumbersBtns?.all || $f9a85cdfa1754a18$var$elements.rateNumbersBtns.all.length !== 5) throw new Error(`Expected 5 rate buttons, found: ${$f9a85cdfa1754a18$var$elements.rateNumbersBtns?.all?.length ?? 0}`);
};
const $f9a85cdfa1754a18$export$4c2b7b1499ae95fe = ()=>{
    $f9a85cdfa1754a18$var$elements.rateNumbersBtns.all.forEach((btn)=>{
        btn.setAttribute("data-selected", "false");
        btn.setAttribute("aria-checked", "false");
        btn.classList.remove("active:bg-orange-500");
    });
};
const $f9a85cdfa1754a18$export$e69d1b52a89def23 = (element)=>{
    const selectedElement = element;
    selectedElement.setAttribute("data-selected", "true");
    selectedElement.setAttribute("aria-checked", "true");
    selectedElement.classList.add("active:bg-orange-500");
};
const $f9a85cdfa1754a18$export$f26e56027e652d0f = (rate)=>{
    const { star1: star1, star2: star2, star3: star3, star4: star4, star5: star5 } = $f9a85cdfa1754a18$var$elements.starImages;
    if (rate === 1) return [
        star1
    ];
    else if (rate === 2) return [
        star1,
        star2
    ];
    else if (rate === 3) return [
        star1,
        star2,
        star3
    ];
    else if (rate === 4) return [
        star1,
        star2,
        star3,
        star4
    ];
    else if (rate === 5) return [
        star1,
        star2,
        star3,
        star4,
        star5
    ];
};
const $f9a85cdfa1754a18$export$3792f22e1e540258 = ()=>{
    $f9a85cdfa1754a18$var$elements.starImages.all.forEach((star)=>{
        star.classList.add("invisible");
    });
};
const $f9a85cdfa1754a18$export$743a8ea1963e9c5b = (arrayOfImgs)=>{
    const activeStars = arrayOfImgs;
    activeStars.forEach((star)=>{
        star.classList.remove("invisible");
    });
};
const $f9a85cdfa1754a18$export$333c4084290bc216 = ()=>{
    $f9a85cdfa1754a18$var$elements.errorMessage.classList.remove("flex");
    $f9a85cdfa1754a18$var$elements.errorMessage.classList.add("hidden");
};
const $f9a85cdfa1754a18$export$f3b8e31d958a9f24 = ()=>{
    $f9a85cdfa1754a18$var$elements.errorMessage.classList.remove("hidden");
    $f9a85cdfa1754a18$var$elements.errorMessage.classList.add("flex");
};
const $f9a85cdfa1754a18$export$4b0c7edbfe4a28d1 = ()=>{
    $f9a85cdfa1754a18$var$elements.thankYouPopup.classList.remove("hidden");
    $f9a85cdfa1754a18$var$elements.thankYouPopup.classList.add("flex");
    $f9a85cdfa1754a18$var$elements.thankYouPopup.setAttribute("tabindex", "-1");
    $f9a85cdfa1754a18$var$elements.thankYouPopup.focus();
};
const $f9a85cdfa1754a18$export$dfe717cd91d47ad9 = ()=>{
    $f9a85cdfa1754a18$var$elements.thankYouPopup.classList.remove("flex");
    $f9a85cdfa1754a18$var$elements.thankYouPopup.classList.add("hidden");
};
const $f9a85cdfa1754a18$export$cca3836c855a727c = (rate)=>{
    $f9a85cdfa1754a18$var$elements.popupSelectedRate.textContent = rate;
};
const $f9a85cdfa1754a18$export$634537741854f582 = ()=>{
    $f9a85cdfa1754a18$var$elements.rateAndSubmitSection.classList.remove("hidden");
    $f9a85cdfa1754a18$var$elements.rateAndSubmitSection.classList.add("flex");
};
const $f9a85cdfa1754a18$export$53a7f497a11c30c5 = ()=>{
    $f9a85cdfa1754a18$var$elements.rateAndSubmitSection.classList.remove("flex");
    $f9a85cdfa1754a18$var$elements.rateAndSubmitSection.classList.add("hidden");
};


/**
 * Initialize app
 */ const $388b617130f03bd4$var$init = ()=>{
    // Initialize DOM
    $f9a85cdfa1754a18$export$5ac527444e5e2edd();
    // Validates DOM elements and throw error in case one of them does not exist
    $f9a85cdfa1754a18$export$7fa453720b850f25();
    // Setup event listeners
    $388b617130f03bd4$var$setupEventListeners();
};
/**
 *Set up all event listeners
 */ const $388b617130f03bd4$var$setupEventListeners = ()=>{
    // Rating numbers buttons
    const allNumbersBtns = document.querySelectorAll(".rate-number");
    allNumbersBtns.forEach((button, index)=>{
        button.addEventListener("click", $388b617130f03bd4$var$handleRateSelection);
        button.addEventListener("keydown", (e)=>$388b617130f03bd4$var$handleRateKeydown(e, index));
    });
    // Submit button
    const submitButton = document.getElementById("submit-button");
    submitButton.addEventListener("click", (e)=>{
        // Stop propagation to prevent the document click listener from immediately closing the thank-you popup after submit
        e.stopPropagation();
        $388b617130f03bd4$var$handleSubmit();
    });
    // Close thank you popup when pressing ESC key
    document.addEventListener("keydown", (e)=>{
        const thankYouPopup = document.getElementById("thank-you-section");
        if (!thankYouPopup.classList.contains("hidden")) {
            if (e.key === "Escape") {
                $ce3de23872348272$export$aad8462122ac592b();
                $f9a85cdfa1754a18$export$dfe717cd91d47ad9();
                $f9a85cdfa1754a18$export$3792f22e1e540258();
                $f9a85cdfa1754a18$export$634537741854f582();
            }
        }
    });
    // Close thank you popup when clicking anywhere on the screen (intentional: closes even on clicks inside the popup)
    document.addEventListener("click", (e)=>{
        const thankYouPopup = document.getElementById("thank-you-section");
        if (!thankYouPopup.classList.contains("hidden")) {
            $ce3de23872348272$export$aad8462122ac592b();
            $f9a85cdfa1754a18$export$dfe717cd91d47ad9();
            $f9a85cdfa1754a18$export$3792f22e1e540258();
            $f9a85cdfa1754a18$export$634537741854f582();
        }
    });
};
/**
 * Handles rate selection
 */ const $388b617130f03bd4$var$handleRateSelection = (event)=>{
    const selectedRateButton = event.currentTarget;
    const selectedRateNumber = Number(selectedRateButton.dataset.rate);
    const visibleStarImgs = $f9a85cdfa1754a18$export$f26e56027e652d0f(selectedRateNumber);
    // Update state
    $ce3de23872348272$export$4f71040b6c38b2f4(selectedRateButton); //sets current selected button
    $ce3de23872348272$export$e0729daa42e99137(selectedRateNumber); // sets current selected number
    // Update UI
    $f9a85cdfa1754a18$export$4c2b7b1499ae95fe(); // Remove active state from other rating buttons
    $f9a85cdfa1754a18$export$e69d1b52a89def23(selectedRateButton); //make selected button active
    $f9a85cdfa1754a18$export$3792f22e1e540258(); //in case there are visible star images hide them
    $f9a85cdfa1754a18$export$743a8ea1963e9c5b(visibleStarImgs);
    $f9a85cdfa1754a18$export$333c4084290bc216();
};
/**
 *
 * @param {event} e
 * @param {} index
 */ const $388b617130f03bd4$var$handleRateKeydown = (e, index)=>{
    const allNumbersBtns = document.querySelectorAll(".rate-number");
    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
        e.preventDefault();
        const next = allNumbersBtns[index + 1] ?? allNumbersBtns[0];
        next.focus();
        next.click();
    }
    if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
        e.preventDefault();
        const prev = allNumbersBtns[index - 1] ?? allNumbersBtns[allNumbersBtns.length - 1];
        prev.focus();
        prev.click();
    }
};
/**
 * Handles submit button click
 */ const $388b617130f03bd4$var$handleSubmit = ()=>{
    // Show error if no rate number button is selected
    if (!$ce3de23872348272$export$ca000e230c0caa3e.selectedRateButton) {
        $f9a85cdfa1754a18$export$f3b8e31d958a9f24();
        return;
    }
    $f9a85cdfa1754a18$export$53a7f497a11c30c5();
    $f9a85cdfa1754a18$export$4b0c7edbfe4a28d1();
    $f9a85cdfa1754a18$export$cca3836c855a727c($ce3de23872348272$export$ca000e230c0caa3e.selectedRate);
};
/**
 * Start the app when DOM is ready
 */ if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $388b617130f03bd4$var$init);
else $388b617130f03bd4$var$init();


//# sourceMappingURL=repo.5940e342.js.map
